export default function BookThankYouPage() {
  return (
    <main className="public-home book-thank-you-page">
      <header className="public-header">
        <a className="public-brand" href="/" aria-label="Calm But Capable home">
          <img src="/logo-white.png" alt="" className="public-logo" />
          <span>Calm But Capable</span>
        </a>
      </header>
      <section className="book-thank-you-card">
        <p className="public-kicker">Order received</p>
        <h1>Thank you for beginning with us.</h1>
        <p>
          Your payment has been received. We will email you when your book has
          been dispatched, together with information about the free workshop
          and your optional Founder Guidance Call.
        </p>
        <p className="book-thank-you-help">
          If you have any questions, email <a href="mailto:hello@calmbutcapable.com">hello@calmbutcapable.com</a>.
        </p>
        <a className="book-button" href="/sanctuary">Explore The Sanctuary</a>
      </section>
    </main>
  );
}
